import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import Navbar from "@/components/Navbar";
import { Save } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminConfig = () => {
  const navigate = useNavigate();
  const email = localStorage.getItem("userEmail") || "";
  const role = localStorage.getItem("userRole");

  const [amount, setAmount] = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!email) {
      navigate("/register");
      return;
    }
    if (role !== "admin") {
      toast.error("Admin access required");
      navigate("/dashboard");
      return;
    }
    fetchConfig();
  }, [email, role, navigate]);

  const fetchConfig = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API}/admin/config`, {
        params: { admin_email: email },
        headers: { "x-admin-email": email },
      });
      setAmount(response.data?.payment_amount || "");
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to load configuration");
    } finally {
      setLoading(false);
    }
  };

  const saveConfig = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const response = await axios.post(`${API}/admin/config/payment-amount`, {
        admin_email: email,
        amount: amount,
      });
      setAmount(response.data?.payment_amount || "");
      toast.success("Payment amount updated");
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to save configuration");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div>
      <Navbar />
      <div className="dashboard-page">
        <div className="dashboard-container">
          <div className="dashboard-header">
            <div>
              <h1>Configuration</h1>
              <p>Manage assessment activation messaging.</p>
              <div style={{ display: "flex", gap: "0.5rem", marginTop: "0.75rem", flexWrap: "wrap" }}>
                <button className="btn-secondary" onClick={() => navigate("/dashboard")}>
                  Sections
                </button>
                <button className="btn-secondary" onClick={() => navigate("/admin-results")}>
                  Assessee Reports
                </button>
                <button className="btn-secondary" onClick={() => navigate("/admin-students")}>
                  Assessees
                </button>
                <button className="btn-secondary active-tab">Configuration</button>
              </div>
            </div>
          </div>

          {loading ? (
            <div className="auth-card">
              <p>Loading configuration...</p>
            </div>
          ) : (
            <form className="panel-card" onSubmit={saveConfig} style={{ maxWidth: 520 }}>
              <label className="form-label">Assessment activation amount (INR)</label>
              <input
                className="form-input"
                type="number"
                min="0"
                step="1"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                placeholder="Enter amount in rupees"
              />
              <button className="btn-primary" type="submit" disabled={saving} style={{ marginTop: "0.75rem" }}>
                <Save size={16} />
                {saving ? "Saving..." : "Save"}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminConfig;
